<template>
  <div
    class="app-card-buttons"
    :class="{ horizontal, 'negative-margin': negativeMargin }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppCardButtons',

  props: {
    horizontal: {
      type: Boolean,
      default: true,
    },

    negativeMargin: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    scrollToCard(element) {
      if (!element) return

      return app.horizontalScrollElement({
        element,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@use '@/styles/settings.scss' as *;
@use '@/styles/functions.scss' as *;

.app-card-buttons {
  display: flex;
  flex-wrap: wrap;

  &::-webkit-scrollbar {
    display: none;
  }

  &.negative-margin {
    padding: $defaultPadding;
  }

  &.horizontal {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;

    &::after {
      content: '';
      min-width: $defaultPadding;
    }

    :deep(.app-card-button) {
      margin-top: 0;

      &:first-child {
        margin-left: 0;
      }
    }

    &.negative-margin {
      margin-left: -#{$defaultPadding};
      margin-right: -#{$defaultPadding};
    }
  }
}
</style>
